var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidecart-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.sidecartOpen
          ? _c("div", {
              staticClass: "sidecart__overlay",
              on: { click: _vm.close },
            })
          : _vm._e(),
      ]),
      _c("transition", { attrs: { name: "off-canvas-right" } }, [
        _vm.sidecartOpen
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "touch",
                    rawName: "v-touch:swipe.right",
                    value: _vm.close,
                    expression: "close",
                    arg: "swipe",
                    modifiers: { right: true },
                  },
                ],
                staticClass: "sidecart",
              },
              [
                _c(
                  "div",
                  { staticClass: "sidecart__header" },
                  [
                    _c(
                      "div",
                      { staticClass: "sidecart__header-icon" },
                      [
                        _c("icon-button", {
                          attrs: {
                            icon: "cart",
                            width: "26px",
                            height: "21px",
                            label: "Open Cart",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$store.dispatch("cart/openSidecart")
                            },
                          },
                        }),
                        _c(
                          "span",
                          { staticClass: "sidecart__header-icon__quantity" },
                          [_vm._v(_vm._s(_vm.totalItems))]
                        ),
                      ],
                      1
                    ),
                    _c("h2", { staticClass: "sidecart__title" }, [
                      _vm._v("Shopping Cart"),
                    ]),
                    _c("icon-button", {
                      staticClass: "sidecart__close",
                      attrs: {
                        icon: "close",
                        size: "18px",
                        label: "Close side cart",
                      },
                      on: { click: _vm.close },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "sidecart__free-shipping" }, [
                  _vm._v(_vm._s(_vm.freeShippingBarContent)),
                ]),
                _c(
                  "div",
                  { staticClass: "sidecart__container" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _vm.totalItems > 0
                          ? _c(
                              "div",
                              {
                                key: "content",
                                staticClass: "sidecart__contents-wrapper",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "sidecart__contents" },
                                  [
                                    _vm._l(_vm.items, function (item, index) {
                                      return _c("sidecart-line-item", {
                                        key: item.id,
                                        attrs: { item: item, line: index + 1 },
                                      })
                                    }),
                                    _c("div", {
                                      attrs: {
                                        "data-handle": _vm.getLatestItem,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.showUpsell == true
                                      ? _c("div", [
                                          _vm.itemAdded === false
                                            ? _c(
                                                "div",
                                                { staticClass: "upsell_wrap" },
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "upsell_title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.upsellSectionTitle
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sidecart__upsell",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "sidecart__upsell_img",
                                                        attrs: {
                                                          src: _vm.upsellProduct
                                                            .product.image.src,
                                                          alt: _vm.upsellProduct
                                                            .product.title,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sidecart__upsell_product_info",
                                                        },
                                                        [
                                                          _c("h3", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .upsellProduct
                                                                  .product.title
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  _vm.upsellPrice
                                                                )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _vm.upsellProduct
                                                            .product
                                                            .options[0] &&
                                                          _vm.upsellProduct
                                                            .product.options[0]
                                                            .name != "Title"
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "upsell_option",
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .upsellProduct
                                                                          .product
                                                                          .options[0]
                                                                          .name
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.option_1,
                                                                            expression:
                                                                              "option_1",
                                                                          },
                                                                        ],
                                                                      on: {
                                                                        change:
                                                                          [
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              var $$selectedVal =
                                                                                Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                              _vm.option_1 =
                                                                                $event
                                                                                  .target
                                                                                  .multiple
                                                                                  ? $$selectedVal
                                                                                  : $$selectedVal[0]
                                                                            },
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.setVariant()
                                                                            },
                                                                          ],
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .upsellProduct
                                                                        .product
                                                                        .options[0]
                                                                        .values,
                                                                      function (
                                                                        val
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  val,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                val
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.upsellProduct
                                                            .product.options[1]
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "upsell_option",
                                                                },
                                                                [
                                                                  _c("label", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .upsellProduct
                                                                          .product
                                                                          .options[1]
                                                                          .name
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.option_2,
                                                                            expression:
                                                                              "option_2",
                                                                          },
                                                                        ],
                                                                      on: {
                                                                        change:
                                                                          [
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              var $$selectedVal =
                                                                                Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function (
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                              _vm.option_2 =
                                                                                $event
                                                                                  .target
                                                                                  .multiple
                                                                                  ? $$selectedVal
                                                                                  : $$selectedVal[0]
                                                                            },
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.setVariant()
                                                                            },
                                                                          ],
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .upsellProduct
                                                                        .product
                                                                        .options[1]
                                                                        .values,
                                                                      function (
                                                                        val
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  val,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                val
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "button button--primary button--full",
                                                              on: {
                                                                click:
                                                                  _vm.addUpsell,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Add to Cart"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "sidecart__footer" },
                                  [
                                    _c("div", {
                                      staticClass: "sidecart__extra",
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "option-section" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input input--checkbox",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.noteCheckbox,
                                                  expression: "noteCheckbox",
                                                },
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "physical-note",
                                                name: "send-gift-info",
                                                value: "Yes",
                                                onchange: "valueChanged()",
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.noteCheckbox
                                                )
                                                  ? _vm._i(
                                                      _vm.noteCheckbox,
                                                      "Yes"
                                                    ) > -1
                                                  : _vm.noteCheckbox,
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$a = _vm.noteCheckbox,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = "Yes",
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.noteCheckbox =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.noteCheckbox =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.noteCheckbox = $$c
                                                    }
                                                  },
                                                  _vm.noteUpdate,
                                                ],
                                              },
                                            }),
                                            _c("div", {
                                              staticClass:
                                                "input--checkbox__indicator",
                                            }),
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "physical-note" },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(_vm.noteTitle)
                                                ),
                                                _vm.notePrice
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            _vm._f("money")(
                                                              _vm.notePrice
                                                            )
                                                          ) +
                                                          ")"
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tooltip-container",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "tooltip-icon",
                                                  attrs: {
                                                    src: "https://cdn.shopify.com/s/files/1/0779/9179/files/info-icon.svg?v=1605625479",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "tooltip" },
                                                  [_vm._v(_vm._s(_vm.noteInfo))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "gift-note-box" },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.cartNote,
                                              expression: "cartNote",
                                            },
                                          ],
                                          attrs: {
                                            name: "gift-note",
                                            rows: "4",
                                            cols: "50",
                                          },
                                          domProps: { value: _vm.cartNote },
                                          on: {
                                            blur: _vm.handleNote,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.cartNote = $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticClass: "sidecart__subtotal" },
                                      [
                                        _c("span", [_vm._v("Subtotal")]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("money")(_vm.totalPrice)
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("checkout-button", {
                                      staticClass:
                                        "sidecart__checkout-cta button--full",
                                      attrs: { full: true, label: "Checkout" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "sidecart__empty" },
                              [
                                _c(
                                  "p",
                                  { staticClass: "sidecart__empty-message" },
                                  [_vm._v(_vm._s(_vm.emptyText))]
                                ),
                                _c("link-button", {
                                  attrs: {
                                    label: _vm.emptyButtonText,
                                    href: _vm.emptyButtonLink,
                                  },
                                }),
                              ],
                              1
                            ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }